"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TwoFactorWithPhoneValidateSmsViewContainer = void 0;
var _SourceProvider = require("../SourceProvider");
var _TwoFactorWithPhoneValidateSmsViewContainer = require("./TwoFactorWithPhoneValidateSmsViewContainer");
const TwoFactorWithPhoneValidateSmsViewContainer = exports.TwoFactorWithPhoneValidateSmsViewContainer = (0, _SourceProvider.SourceProvider)(_TwoFactorWithPhoneValidateSmsViewContainer.TwoFactorWithPhoneValidateSmsViewContainer);